<template>
  <div class="">
    <vue-perfect-scrollbar
      class="chat-history--scrollbar"
      ref="chatCenterReport"> 
      <v-container fluid grid-list-lg>
        <v-layout row wrap>
          <v-flex xs12>
            <p class="headline pt-2 pb-0">
              Chat center
            </p>
          </v-flex>
        </v-layout>
        <v-layout row wrap mb-3 v-if="Object.keys(headerMetrics).length > 0">
          <v-flex xs3>
            <v-card hover @click.native="info = true" ripple class="elevation-3 h-100">
              <v-card-text class="px-1">
                <v-tooltip  bottom>
                  <v-layout row wrap slot="activator" justify-center align-center>
                    <v-flex xs3>
                      <v-avatar
                        size="60"
                        class="transparent">
                        <v-icon large class="k-orange-linear-text">fas fa-users</v-icon>
                      </v-avatar>
                    </v-flex>
                    <v-flex xs9 pl-3>
                      <v-layout row wrap>
                        <v-flex xs12 class="headline pb-0">
                          {{ headerMetrics.waiting || 0 }}
                        </v-flex>
                        <v-flex xs12 class="body-3 pt-0 k-grey-text text-small">
                          En espera
                        </v-flex>                        
                      </v-layout>
                    </v-flex>
                    <v-flex v-if="headerWaiting.waiting" xs12 class="body-3 pt-0 k-grey-text little-text text-xs-center">
                      <span> Promedio de espera: </span>
                      <span> {{headerWaiting.waiting.humanize()}} </span>
                    </v-flex>
                  </v-layout>
                  <span>Conversaciones sin operador asignado</span>
                </v-tooltip>
              </v-card-text>
            </v-card>
          </v-flex>
          <v-flex xs3>
            <v-card class="elevation-3 h-100">
              <v-card-text class="px-1">
                <v-tooltip bottom>
                  <v-layout row wrap slot="activator" justify-center align-center>
                    <v-flex xs3>
                      <v-avatar
                        size="60"
                        class="transparent">
                        <span class="fa-stack">
                          <v-icon large class="k-orange-linear-text fa-stack-1x">far fa-comment</v-icon>
                          <v-icon large class="k-orange-linear-text fa-stack-halfx">fas fa-ellipsis-h</v-icon>
                        </span>
                      </v-avatar>
                    </v-flex>
                    <v-flex xs9 pl-3>
                      <v-layout row wrap>
                        <v-flex xs12 class="headline pb-0">
                          {{ headerMetrics.unanswered || 0 }}
                        </v-flex>
                        <v-flex xs12 class="body-3 pt-0 k-grey-text text-small">
                          Por responder
                        </v-flex>
                      </v-layout>
                    </v-flex>
                    <v-flex v-if="headerWaiting.unanswered" xs12 class="body-3 pt-0 k-grey-text little-text text-xs-center">
                      <span> Promedio de respuesta: </span>
                      <span> {{headerWaiting.unanswered.humanize()}} </span>
                    </v-flex>
                  </v-layout>
                  <span>Cantidad de conversaciones por responder</span>
                </v-tooltip>
              </v-card-text>
            </v-card>
          </v-flex>
          <v-flex xs3>
            <v-card class="elevation-3 h-100">
              <v-card-text class="px-1">
                <v-tooltip bottom>
                  <v-layout row wrap slot="activator" justify-center align-center>
                    <v-flex xs3>
                      <v-avatar
                        size="60"
                        class="transparent">
                        <v-icon large class="k-orange-linear-text">fas fa-clock</v-icon>
                      </v-avatar>
                    </v-flex>
                    <v-flex xs9 pl-3>
                      <v-layout row wrap>
                        <v-flex xs12 class="headline pb-0">
                          {{ headerMetrics.unsolved || 0 }}
                        </v-flex>
                        <v-flex xs12 class="body-3 pt-0 k-grey-text text-small">
                          Por resolver
                        </v-flex>
                      </v-layout>
                    </v-flex>
                    <v-flex v-if="headerWaiting.unsolved" xs12 class="body-3 pt-0 k-grey-text little-text text-xs-center">
                      <span> Promedio para resolver: </span>
                      <span> {{headerWaiting.unsolved.humanize()}} </span>
                    </v-flex>
                  </v-layout>
                  <span>Cantidad de conversaciones por resolver</span>
                </v-tooltip>
              </v-card-text>
            </v-card>
          </v-flex>
          <v-flex xs3>
            <v-card class="elevation-3 h-100">
              <v-card-text class="px-1">
                <v-tooltip bottom>
                  <v-layout row wrap slot="activator" justify-center align-center>
                    <v-flex xs3>
                      <v-avatar
                        size="60"
                        class="transparent">
                        <span class="fa-stack fa-stack-1x">
                          <v-icon large class="k-orange-linear-text fa-stack-1x">far fa-comment</v-icon>
                          <v-icon large class="k-orange-linear-text fa-stack-halfx">fas fa-check</v-icon>
                        </span>
                      </v-avatar>
                    </v-flex>
                    <v-flex xs9 pl-3>
                      <v-layout row wrap>
                        <v-flex xs12 class="headline pb-0">
                          {{ headerMetrics.solved || 0 }}
                        </v-flex>
                        <v-flex xs12 class="body-3 pt-0 k-grey-text text-small">
                          Resueltos
                        </v-flex>
                      </v-layout>
                    </v-flex>
                    <v-flex v-if="headerWaiting.solved" xs12 class="body-3 pt-0 k-grey-text little-text text-xs-center">
                      <span> Promedio en resolver: </span>
                      <span> {{headerWaiting.solved.humanize()}} </span>
                    </v-flex>
                  </v-layout>
                  <span>Cantidad de conversaciones resueltas</span>
                </v-tooltip>
              </v-card-text>
            </v-card>
          </v-flex>
        </v-layout>
        <v-layout row wrap v-if="user.role === 'admin'">
          <v-flex xs8>
            <p class="headline pt-2 pb-0">
              Agentes
            </p>
          </v-flex>
        </v-layout>
        <v-layout row wrap mb-3 v-if="user.role === 'admin'">
          <v-flex xs12 md12 pb-0>
            <v-layout column>
              <v-flex md12 pt-0>
                <v-data-table
                  :headers="headers"
                  :items="cleanUsers"
                  hide-actions
                  no-data-text="No se encontraron registros"
                  class="mt-1 bordered elevation-2 white"
                >
                  <template slot="headerCell" slot-scope="props" class="k-orange-linear">
                    <v-tooltip bottom>
                      <span slot="activator" v-html="props.header.text">
                      </span>
                      <span>
                        {{ props.header.descrip }}
                      </span>
                    </v-tooltip>
                  </template>
                  <template slot="items" slot-scope="props" v-if="props.item">
                    <td>
                      <v-icon class="text-small mr-1 green--text darken-1" v-if="props.item.chat_center_online">
                        fas fa-comment-dots
                      </v-icon>
                       <v-icon class="text-small mr-1 grey--text  lighten-2"  v-if="!props.item.chat_center_online">
                        fas fa-comment-slash
                      </v-icon>
                      {{ props.item.first_name }} {{ props.item.last_name }}
                    </td>
                    <td class="text-xs-center">
                      {{ props.item.unanswered || 0 }}
                    </td>
                    <td class="text-xs-center">
                      {{ props.item.unsolved || 0 }}
                    </td>
                    <td class="text-xs-center">
                      {{ props.item.solved || 0 }}
                    </td>
                  </template>
                  <template slot="footer" v-if="users.length > 0">
                    <td>
                      <strong>Total</strong>
                    </td>
                    <td class="text-xs-center">
                      <strong>{{ userTotal.unanswered || 0 }}</strong>
                    </td>
                    <td class="text-xs-center">
                      <strong>{{ userTotal.unsolved || 0 }}</strong>
                    </td>
                    <td class="text-xs-center">
                      <strong>{{ userTotal.solved || 0 }}</strong>
                    </td>
                  </template>
                </v-data-table>
              </v-flex>
            </v-layout>
          </v-flex>
        </v-layout>
        <v-layout row wrap mb-3>
          <v-flex md12>
            <v-layout row wrap justify-center align-center>
              <v-flex md4>
                <p class="headline pb-0 mb-0">
                  Categorías
                </p>
              </v-flex>
              <v-flex md8>
                <v-layout row wrap justify-end>
                  <v-flex md6 >
                    <v-select
                      :items="typeFilters"
                      v-model="filters.type"
                      label="Tipo de fecha"
                      solo
                      color="grey"
                    ></v-select>
                  </v-flex>
                  <v-flex md6>
                    <v-menu
                      ref="from"
                      :close-on-content-click="false"
                      :nudge-right="40"
                      :return-value.sync="filters.date"
                      transition="scale-transition"
                      min-width="290px"
                      lazy
                      offset-y
                      full-width>
                        <v-text-field
                          slot="activator"
                          v-model="formatedDate"
                          class="k-orange-linear-text"
                          prepend-icon="event"
                          label="Periodo"
                          readonly
                          solo>
                        </v-text-field>
                        <v-date-picker
                          v-model="filters.date"
                          @input="$refs.from.save(filters.date)"
                          locale="es"
                          :type="filters.type"
                          color="k-orange-linear">
                        </v-date-picker>
                    </v-menu>
                  </v-flex>
                </v-layout>
              </v-flex>
              <v-flex xs12>
                <v-data-table
                  :headers="categoryHeaders"
                  :items="categories"
                  hide-actions
                  no-data-text="No se encontraron registros"
                  class="mt-1 bordered elevation-2 white">
                  <template slot="headerCell" slot-scope="props" class="k-orange-linear text-xs-center">
                    <span slot="activator">
                      {{ props.header.text }}
                    </span>
                  </template>
                  <template slot="items" slot-scope="props">
                    <td >
                      {{ props.item.name }}
                    </td>
                    <td>
                      {{ props.item.total }}
                    </td>
                  </template>
                </v-data-table>
              </v-flex>
            </v-layout>
          </v-flex>
          <!-- <v-flex md5>
            <v-flex md12>
              <p class="headline pb-0">
                Ultimos chats
              </p>
            </v-flex>
            <chats-list :list-number="5" :chat-filters="{}" :trigger="true" :limit="6" :do-scroll="false"></chats-list>            
          </v-flex> -->
        </v-layout>
      </v-container>
    </vue-perfect-scrollbar>
    <waiting :show="info" @close="info = false"/>
  </div>
</template>

<script>
import moment from 'moment';
import VuePerfectScrollbar from 'vue-perfect-scrollbar';
import ChatsList from '@/components/chat_center/ChatsList';
import Waiting from '@/components/reports/chat_center/WaitingChannel';
import _ from 'lodash';
/* eslint-disable radix */

export default {
  components: {
    ChatsList,
    VuePerfectScrollbar,
    Waiting,
  },
  mounted() {
    if (this.user.role !== 'agent') {
      this.getChatsMetrics();
    }
    this.getHeaderMetrics();
    this.getCategoriesMetrics();
  },
  destroyed() {
    this.stopListeningEvents();
  },
  data() {
    return {
      users: [],
      categories: [],
      headerMetrics: {
        waiting: 0,
        unanswered: 0,
        unsolved: 0,
        solved: 0,
      },
      headerWaiting: {
        waiting: 0,
        unanswered: 0,
        unsolved: 0,
        solved: 0,
      },
      info: false,
      latestChats: [],
      equivalent: {
        Espera: 'waiting',
        Reasignado: 'waiting',
        'Por asignar': 'waiting',
        'Por responder': 'unanswered',
        'Por resolver': 'unsolved',
        Ausente: 'unsolved',
        Resuelto: 'solved',
      },
      headers: [
        {
          text: 'Usuarios',
          sortable: false,
          value: 'first_name',
          descrip: 'Usuarios que han gestionado correspondiente a la fecha',
        },
        {
          text: 'Por responder',
          align: 'center',
          sortable: false,
          value: 'unanswered',
          descrip: 'Cantidad de conversaciones por responder asigndos al agente',
        },
        {
          text: 'Por resolver',
          align: 'center',
          sortable: false,
          value: 'unsolved_chats',
          descrip: 'Cantidad de conversaciones por resolver asigndos al agente',
        },
        {
          text: 'Resueltos',
          align: 'center',
          sortable: false,
          value: 'resolved_chats',
          descrip: 'Cantidad de conversaciones resueltas por el agente',
        },
      ],
      categoryHeaders: [
        {
          text: 'Categorias',
          sortable: false,
          value: 'name',
        },
        {
          text: 'Total',
          sortable: false,
          value: 'total',
        },
      ],
      filters: {
        type: 'date',
        date: moment().format('YYYY-MM-DD'),
      },
      typeFilters: [
        {
          text: 'Mensual',
          value: 'month',
        },
        {
          text: 'Diario',
          value: 'date',
        },
      ],
    };
  },
  computed: {
    cleanUsers() {
      return _.uniqBy(_.compact(this.users), 'id');
    },
    channel() {
      return `company.${this.user.company_id}.`;
    },
    formatedDate() {
      const typeFormat = this.filters.type === 'month' ? 'MM/YYYY' : 'DD/MM/YYYY';
      return moment(this.filters.date, 'YYYY-MM-DD').format(typeFormat);
    },
    user() {
      return this.$auth.user();
    },
    userTotal() {
      const totals = {
        totalChats: 0,
        unanswered: 0,
        unsolved: 0,
        solved: 0,
      };
      if (this.users.length > 0) {
        this.users.map((el) => {
          totals.unanswered += !isNaN(parseInt(el.unanswered)) ? parseInt(el.unanswered) : 0;
          totals.unsolved += !isNaN(parseInt(el.unsolved)) ? parseInt(el.unsolved) : 0;
          totals.solved += !isNaN(parseInt(el.solved)) ? parseInt(el.solved) : 0;
          return el;
        });
      }
      return totals;
    },
  },
  methods: {
    startListeningEvents() {
      if (this.user.role !== 'agent') {
        window.Echo.private(`${this.channel}chatCenterReport`)
          .listen('.ChangeChatOnlineStatus', (event) => {
            this.changeOnlineStatus(event);
          });
      }
      window.Echo.private(`${this.channel}chatCenterCount`)
        .listen('.ChatCenterUpdated', (event) => {
          this.countChats(event);
        }).listen('.ChatCenterCreated', (event) => {
          this.countChats(event);
        });
    },
    /* eslint-disable camelcase */
    changeOnlineStatus({ id, first_name, last_name, chat_center_online }) {
      const user = this.users.find(x => x.id === id);
      if (user) {
        user.chat_center_online = chat_center_online;
      } else {
        this.$set(this.users, this.users.length, {
          id,
          first_name,
          last_name,
          chat_center_online,
          unanswered: 0,
          unsolved: 0,
          solved: 0,
        });
      }
    },
    /* eslint-enable camelcase */
    stopListeningEvents() {
      window.Echo.leave(`${this.channel}chatCenterReport`);
      window.Echo.leave(`${this.channel}chatCenterCount`);
    },
    getLatestIncomingChats() {
      this.axios.get('/chats_center?limit=6&offset=0').then((response) => {
        this.latestChats = response.data;
      });
    },
    getHeaderMetrics() {
      this.axios.get('/chat_center/reports/chat_header_metrics').then((response) => {
        this.headerMetrics = _.pick(response.data, ['waiting', 'unsolved', 'unanswered', 'solved']);
        const times = response.data.average;
        if (Object.keys(times).length > 0) {
          this.headerWaiting.waiting = moment.duration(times.waiting, 'seconds');
          this.headerWaiting.unanswered = moment.duration(times.unanswered, 'seconds');
          this.headerWaiting.solved = moment.duration(times.waiting + times.unanswered, 'seconds');
        }
        this.startListeningEvents();
      });
    },
    getChatsMetrics() {
      this.axios.get('/chat_center/reports/chat_metrics').then((response) => {
        this.users = response.data;
      });
    },
    countChats(event) {
      let user = _.find(this.users, { id: event.chatCenter.user_id });
      const statusOld = this.equivalent[event.chatCenter.status_old];
      const statusNew = this.equivalent[event.chatCenter.status];
      if (this.user.role !== 'agent') {
        if (!user) {
          const temp = _.pick(event.chatCenter, ['user']);
          if (temp.id) {
            user = {
              chat_center_online: 1,
              id: temp.id,
              first_name: temp.first_name,
              last_name: temp.last_name,
              unanswered: 0,
              unsolved: 0,
              solved: 0,
            };
            this.users.push(user);
          }
        }
        if (user) {
          if (Object.prototype.hasOwnProperty.call(user, statusOld)) {
            if (user[statusOld] > 0) {
              user[statusOld] = parseInt(user[statusOld]) - 1;
            } else {
              user[statusOld] = 0;
            }
          }
          if (Object.prototype.hasOwnProperty.call(user, statusNew)) {
            user[statusNew] = parseInt(user[statusNew]) + 1;
          }
        }
      } else {
        user = event.chatCenter.user_id;
      }
      if (Object.prototype.hasOwnProperty.call(this.headerMetrics, statusOld)) {
        if (this.user.role !== 'agent' || (this.user.role === 'agent' && this.user.id === user) || statusOld === 'waiting') {
          if (this.headerMetrics[statusOld] > 0) {
            this.headerMetrics[statusOld] = parseInt(this.headerMetrics[statusOld]) - 1;
          } else {
            this.headerMetrics[statusOld] = 0;
          }
        }
      }
      if (Object.prototype.hasOwnProperty.call(this.headerMetrics, statusNew)) {
        if (this.user.role !== 'agent' || (this.user.role === 'agent' && this.user.id === user) || statusNew === 'waiting') {
          this.headerMetrics[statusNew] = parseInt(this.headerMetrics[statusNew]) + 1;
        }
      }
    },
    getCategoriesMetrics() {
      this.axios.get(`/chat_categories/reports/chat_category_metrics?date=${this.filters.date}&type=${this.filters.type}`).then((response) => {
        this.categories = response.data;
      });
    },
  },
  watch: {
    filters: {
      handler() {
        this.getCategoriesMetrics();
      },
      deep: true,
    },
  },
};
</script>

<style scoped>
  .minCard {
    min-height: 136px;
  }
  .chat-history--scrollbar > div {
    height: calc(100vh - 55px);
  }
  .layout.row.wrap {
    height: auto;
  }
  .fas.fa-stack-halfx {
    font-size: 16px !important;
    left: 0;
    position: absolute;
    text-align: center;
    width: 100%;
  }
  .text-small {
    font-size: 12px;
  }
  .little-text {
    font-size: 10px;
  }
  .d-block {
    display: block;
  }
  .roundCheck {
    height: 6px;
    position: absolute;
    width: 6px;
    border-radius: 100%;
    margin-left: 3px;
  }
</style>


// WEBPACK FOOTER //
// src/components/reports/chat_center/Chats.vue